export const buttonIcon = 'h-4 w-4 text-white mr-2';
export const label =
  'block text-base leading-snug font-body font-semibold text-textMid my-4';
